import data from "@/data/data"

const fetchAllModels = () => {
  return data.models
}

export { fetchAllModels }
